import { ExternalIntegration, ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { BlogPlatformIntegration } from 'types'

export const getConnectedBlogIntegration = (integrations: ExternalIntegration[]): ExternalIntegration | null => {
  const blogProviders: BlogPlatformIntegration[] = [
    ExternalIntegrationEnum.WordPress,
    ExternalIntegrationEnum.GoHighLevel,
    ExternalIntegrationEnum.Wix,
  ]

  return (
    integrations.find((integration) => blogProviders.includes(integration.provider as BlogPlatformIntegration)) || null
  )
}

export const hasBlogIntegrationConnected = (integrations: ExternalIntegration[]): boolean => {
  return getConnectedBlogIntegration(integrations) !== null
}

export const canConnectBlogProvider = (
  integrations: ExternalIntegration[],
  providerToConnect: BlogPlatformIntegration,
): boolean => {
  const connectedBlogIntegration = getConnectedBlogIntegration(integrations)

  if (!connectedBlogIntegration) {
    return true
  }

  return connectedBlogIntegration.provider === providerToConnect
}

export const getConnectedBlogProviderName = (integrations: ExternalIntegration[]): string | null => {
  const connectedIntegration = getConnectedBlogIntegration(integrations)

  if (!connectedIntegration) {
    return null
  }

  switch (connectedIntegration.provider) {
    case ExternalIntegrationEnum.WordPress:
      return 'WordPress'
    case ExternalIntegrationEnum.GoHighLevel:
      return 'GoHighLevel'
    case ExternalIntegrationEnum.Wix:
      return 'Wix'
    default:
      return null
  }
}

export const getBlogIntegrationRestrictionMessage = (
  integrations: ExternalIntegration[],
  attemptedProvider: BlogPlatformIntegration,
): string | null => {
  const connectedProviderName = getConnectedBlogProviderName(integrations)

  if (!connectedProviderName) {
    return null
  }

  let attemptedProviderName: string
  if (attemptedProvider === ExternalIntegrationEnum.WordPress) {
    attemptedProviderName = 'WordPress'
  } else if (attemptedProvider === ExternalIntegrationEnum.GoHighLevel) {
    attemptedProviderName = 'GoHighLevel'
  } else {
    attemptedProviderName = 'Wix'
  }

  if (connectedProviderName === attemptedProviderName) {
    return null
  }

  return `You can connect one blog platform per workspace`
}
